import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerUser } from '@app/manage-users/models/customer-user.model';
import { SortableSectionHeader } from '@shared/components/sortable-section/models/sortable-section.model';

@Component({
  template: '',
})
export class ManageUsersListSectionBaseComponent {
  @Input() user: CustomerUser;
  @Input() selectedHeader: string;
  @Input() headers: SortableSectionHeader[];
  @Input() currentUserId: number;
  @Output() updateSort: EventEmitter<any> = new EventEmitter();
  @Output() openActionSheet: EventEmitter<any> = new EventEmitter();
  @Output() openExtendedView: EventEmitter<CustomerUser> = new EventEmitter();

  constructor() {}

  openUserOptions(user: CustomerUser) {
    this.openActionSheet.emit(user);
  }

  openUserExtendedView(user: CustomerUser) {
    if (this.currentUserId === user.userId) return;
    this.openExtendedView.emit(user);
  }
}
